<div class="question-row" [class.question-row--readonly]="isStudent">
  <button
    type="button"
    class="button-input"
    [ngClass]="getColor()"
    (click)="!isStudent && incrementScore()"
    [disabled]="isStudent"
    [attr.aria-label]="text + ' : score ' + score"
    [attr.title]="text">
  </button>

  <span class="question-text">{{ text }}</span>
</div>
